import {
	apiRequest
} from '../api.js'

// 优秀项目经理

//新增基本信息
export function getManagerInfo(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg'
	apiRequest(config)
}
//新增获奖信息
export function getWinningInfo(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-award'
	apiRequest(config)
}

//新增资质信息
export function saveQua(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-cx-qua'
	apiRequest(config)
}

//上传文件附件
export function getUploadFile(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/upload-data'
	apiRequest(config)
}

//初审打分
export function givePoint(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/give-point'
	apiRequest(config)
}

//获取项目明细
export function getProjectDetail(config){
	config.method = 'get'
	config.url = '/proapi/v1/project/get-project-detail'
	apiRequest(config)
}

// 二期新增
// 确认提交
export function sureSubmit(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/submit'
	apiRequest(config)
}

// 确认提交
export function getApplyDetail(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/get-application-detail'
	apiRequest(config)
}

// 获取资料上传的项目
export function getDataItem(config){
	config.method = 'get'
	config.url = '/proapi/v1/application/get-data-item'
	apiRequest(config)
}

// 项目管理成果
export function getBasicA(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg-achieve'
	apiRequest(config)
}

// 优秀安装工程
export function setBasicProgram(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg-iw'
	apiRequest(config)
}

// 确定已完成
export function sureUpdate(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/query-do-modify'
	apiRequest(config)
}

// 新增质量管理小组基本信息
export function setTeamBasicInfo(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg-qa'
	apiRequest(config)
}

//新增先进企业基本信息
export function setAdvanceInfo(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg-enp'
	apiRequest(config)
}

//新增诚信企业基本信息
export function setAdvanceInfoCx(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg-cxenp'
	apiRequest(config)
}

//新增诚信企业评定表的表单
export function saveEva(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg-eva'
	apiRequest(config)
}


// 新增BIM基础信息
export function setBIMBasicInfo(config){
	config.method = 'post'
	config.url = '/proapi/v1/application/add-msg-bim'
	apiRequest(config)
}

// 获取课程类型
export function getCourseType(config){
	config.method = 'get'
	config.url = '/proapi/v1/application/get-course-type'
	apiRequest(config)
}

//设置个人简历
export function setPersonInfo(config) {
	config.method = 'post'
	config.url = '/proapi/v1/application/add-resume'
	apiRequest(config)
}

